import { render, staticRenderFns } from "./SellingPoint.vue?vue&type=template&id=5182f92e&scoped=true&"
import script from "./SellingPoint.vue?vue&type=script&lang=js&"
export * from "./SellingPoint.vue?vue&type=script&lang=js&"
import style0 from "./SellingPoint.vue?vue&type=style&index=0&id=5182f92e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5182f92e",
  null
  
)

export default component.exports